<template lang="pug" src="./html/iPhoneReplacesWallet.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const iPhoneReplacesWalletBody = () => import(/* webpackChunkName: "iphone-replaces-wallet" */ './iPhoneReplacesWallet-Body')

  Vue.component('iPhoneReplacesWalletBody', iPhoneReplacesWalletBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('iPhoneReplacesWalletBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style scoped>
    .article-item {
        background-color: #31298c;
        color: #d4bbc3;
    }
    h1, .heading-caption {
        color: #FFFFFF;
    }
</style>

<style>
    #app.iphone-replaces-wallet #top-header {
        background-color: #0e0a47;
    }
    #app.iphone-replaces-wallet #load-anim {
        stroke: #0e0a47;
    }
</style>
